import { FOUNDERS, FOUNDER_TIMELINE } from "@/lib/data";
import { SectionHead, Reveal, Eyebrow } from "@/components/primitives";

function FounderCard({ f, i }) {
  return (
    <Reveal delay={i * 0.1}>
      <article data-testid={`founder-card-${i}`} className="group overflow-hidden rounded-2xl border border-line bg-panel/70 transition-colors duration-300 hover:border-electric/40">
        <div className="relative">
          <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-electric/10 to-transparent" aria-hidden="true" />
          <img
            src={f.photo}
            alt={`${f.name}, ${f.role} of Avyagrah Tech Innovations`}
            loading="lazy"
            className="aspect-[4/5] w-full bg-gradient-to-b from-panel2 to-abyss object-cover object-top"
          />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-panel to-transparent" aria-hidden="true" />
        </div>
        <div className="p-8">
          <h3 className="font-display text-2xl font-bold tracking-tight text-mist">{f.name}</h3>
          <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.22em] text-electric">{f.role}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {f.expertise.map((e) => (
              <span key={e} className="rounded-full border border-line px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] text-mute">
                {e}
              </span>
            ))}
          </div>
          <p className="mt-5 text-sm leading-relaxed text-mute">{f.bio}</p>
        </div>
      </article>
    </Reveal>
  );
}

export function FounderTimeline() {
  return (
    <Reveal className="mt-16" >
      <div className="relative" data-testid="founder-timeline">
        <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-gradient-to-r from-teal/40 via-line to-electric/40 lg:block" aria-hidden="true" />
        <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {FOUNDER_TIMELINE.map((step, i) => (
            <li key={step} className="relative">
              <span className={`relative z-10 block h-[15px] w-[15px] rounded-full border-2 ${i === FOUNDER_TIMELINE.length - 1 ? "border-teal bg-teal/20" : "border-electric/60 bg-ink"}`} aria-hidden="true" />
              <p className="mt-4 font-display text-sm font-semibold text-mist">{step}</p>
            </li>
          ))}
        </ol>
      </div>
    </Reveal>
  );
}

export default function Founders({ chapter = "Chapter 15 — The Founders", compact = false }) {
  return (
    <section className="border-b border-line py-24 sm:py-32" data-testid="founders-section">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
        <SectionHead
          eyebrow={chapter}
          title="Built From the Ground Up."
          lead={compact ? undefined : "Grassroots financial services to AI-powered infrastructure — the team has lived every layer of the stack it is building."}
        />
        <div className="mt-14 grid gap-6 lg:grid-cols-2">
          {FOUNDERS.map((f, i) => (
            <FounderCard key={f.name} f={f} i={i} />
          ))}
        </div>
        {!compact && <FounderTimeline />}
      </div>
    </section>
  );
}
